<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M23.87 31.39h8.9a6.43 6.43 0 00-1.89-4.74c-1.61-1.38-4.45-1.89-7-1.89s-5.56.56-7.18 2C15.3 28.09 15 30.14 15 32a7.45 7.45 0 002.12 5.51c1.53 1.3 4.24 1.73 6.77 1.73s5.13-.4 6.74-1.72A7 7 0 0032.78 32h-8.91zM33.36 32v6.94h12.38A3.43 3.43 0 0049 35.5a3.51 3.51 0 00-3.26-3.5zM48.78 28.21A3.16 3.16 0 0045.64 25H33.36v6.36h12.49a3.21 3.21 0 002.93-3.15z"/><path d="M56 16v32H8V16h48m1-3H7a2 2 0 00-2 2v34a2 2 0 002 2h50a2 2 0 002-2V15a2 2 0 00-2-2z"/></svg>